export default {
  path: '/todo-templates',
  component: () => import(/* webpackChunkName: "todo-templates" */ './TodoTemplates'),
  meta: {
    requiresAuth: true
  }
}
